import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IRCAElipsisMenu, IOption } from "./RCAElipsisMenuInterfaces";
import { useStyles, paperPropsStyles } from "./RCAElipsisMenu.styles";
import { Button } from "@mui/material";

export const RCAElipsisMenu = ({ options }: IRCAElipsisMenu) => {
    const classes = useStyles();

    const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorElement);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorElement(event.currentTarget);
    };
    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorElement(null);
    };

    return (
        <div>
            <Button
                className={classes.threeDotsMenuButton}
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                color="info"
                variant="outlined"
                onClick={handleClick}
            >
                <MoreHorizIcon />
            </Button>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorElement}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: paperPropsStyles,
                }}
            >
                {options.map((option: IOption, index: number) => (
                    <div key={index}>
                        <MenuItem
                            disabled={option.disabled}
                            className={classes.item}
                            style={{
                                ...(option.customStyles && option.customStyles),
                            }}
                            onClick={(event) => {
                                option.callback();
                                handleClose(event);
                            }}
                        >
                            {option.name}
                        </MenuItem>
                    </div>
                ))}
            </Menu>
        </div>
    );
};
